import { InjectionToken } from "@angular/core";
export const AntiForgeryToken = new InjectionToken<string>('anti-forgery-token');
export const EveReportingUrl = new InjectionToken<string>('eve-reporting-url');